import * as t from 'io-ts';

import type { SelectDefinition } from 'header/types';
import { ViewHelper } from 'portlet/models/viewHelper';

import { define, createSpecSettingsInterface } from './_common';

export interface ViewFormSettingDefinition extends SelectDefinition {
    key: 'VIEW_FORM';
}

/*
 ** `viewForm` setting is available after creating view groups
 ** It's used to quickly switch associated views (ex. Sales Table, Sales Chart...)
 ** That is why `value` is actually a VIEW_ID
 */
const definition: ViewFormSettingDefinition = {
    type: 'Select',
    key: 'VIEW_FORM',
    changeable: true,
    label: 'View form',
    options: [],
    value: '',
    scope: 'user',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const ViewFormSettingDefinition = define({
    key: 'VIEW_FORM',
    label: 'view form',
    definition,
    fromSetting: (_, __, view) => {
        return view?.viewGroup?.form?.toLowerCase();
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: (_, spec, view) => {
        if (!view?.viewGroup) return;

        const options = ViewHelper.getViewGroup(spec, view).members.map(({ form }) => ({
            label: form,
            key: form.toLowerCase(),
        }));

        return options.length > 1
            ? {
                  ...definition,
                  options,
              }
            : undefined;
    },
    replacementTags: definition => ({
        VIEW_FORM: definition.options.find(({ key }) => key === definition.value)?.label || '',
    }),
});
